<template>
  <section id="hero" class="hero d-flex align-items-center">

    <div class="container">
      <div class="row">
        <div class="col-lg-6 d-flex flex-column justify-content-center">
          <h1 data-aos="fade-up">ჩვენ ფინანსების მართვის ახალ გზას ვქმნით</h1>
          <h4 class="mt-3" data-aos="fade-up" data-aos-delay="400">
            პროფესიონალური ფინანსური ხელსაწყოების პლატფორმა მცირე ბიზნესებისთვისა და სტარტაპისთვის.
          </h4>
          <div data-aos="fade-up" data-aos-delay="600">
            <div class="text-center text-lg-start">
              <a href="#about" class="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>რეგისტრაცია</span>
                <i class="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
          <img src="assets/img/hero-img.png" class="img-fluid" alt="">
        </div>
      </div>
    </div>

  </section><!-- End Hero -->
</template>

<script>
export default {
  name: "Slider"
}
</script>

<style scoped>

</style>